import {
  DefaultStudioRectanglePopup,
  DefaultStudioSquarePopup
} from '@appcharge/shared-ui';
import { BannerAspectRatio } from 'constants/enums';

import { EThemes } from '../enums';

import { PopupDesignsMetadata } from './types';

const square: PopupDesignsMetadata = {
  id: BannerAspectRatio.SQUARE,
  version: '1.0.0',
  name: '1:1 Ratio',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/popup_square.png'
  ],
  ratio: '1:1',
  theme: EThemes.ROYAL_BLAST,
  component: DefaultStudioSquarePopup
};

const rectangle: PopupDesignsMetadata = {
  id: BannerAspectRatio.TWO_ON_THREE,
  version: '1.0.0',
  name: '2:3 Ratio',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/popup_rectangle.png'
  ],
  ratio: '2:3',
  theme: EThemes.ROYAL_BLAST,
  component: DefaultStudioRectanglePopup
};

export const popupDesigns = {
  square,
  rectangle
};
